/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";

import { LoadingOutlined } from "@ant-design/icons";
import StarRoundedIcon from "@material-ui/icons/StarRounded";
import { Rating } from "@material-ui/lab";
import { Progress, Spin } from "antd";
import moment from "moment";

import { AxiosInstance, logout } from "../../../utilities";
import LongText from "./LongText";
import styles from "./ReviewComponent.module.css";

const colorCode = ["#76DB98", "#B7EA83", "#F6D757", "#FDDDAB", "#F17A54"];

const ReviewComponent = ({ bandId, cmsData, citySlug }) => {
  const [loading, setLoading] = useState(false);
  const [loadingMore, setLoadingMore] = useState(false);
  const [reviews, setReview] = useState([]);
  const [reviewRatings, setReviewRatings] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [featuredReviews, setFeaturedReviews] = useState(false);

  useEffect(() => {
    (bandId || citySlug) && fetchReviews(bandId, citySlug);
  }, [bandId, currentPage, featuredReviews, citySlug]);

  useEffect(() => {
    (bandId || citySlug) && fetchReviewRatings(bandId, citySlug);
  }, [bandId, citySlug]);
  

  const fetchReviews = async(id, slug) => {
    try{
      setLoading(true)
      let requestData = {
        featured: featuredReviews,
        page: currentPage,
        pageSize: slug ? 8 : 4,
      };
      let resp;
      if(id){
        requestData.bandId = id;
        resp = await AxiosInstance(4009, "application/json").post("/reviews", requestData)
      }else{
        requestData.slug = slug;
        resp = await AxiosInstance(4008, "application/json").post("/city/reviews", requestData)
      }

      const response = resp?.data
      if(response?.status === 200) setReview(response.data);

    }catch(e){}

    handleLoading(false);
    setLoadingMore(false);
  };

  const fetchReviewRatings = async(id, slug) => {
    try{
      let resp;
      if(id) resp = await AxiosInstance(4009, "application/json").get(`/reviewRatings/${id}`)
      else if(slug) resp = await AxiosInstance(4008, "application/json").get(`/city/${slug}/reviewRatings`)

      const response = resp?.data
      if(response?.status === 200) setReviewRatings(response.data);
      else if(response?.status === 400) setReviewRatings([]);
    }catch(err){

    }
  };

  const handleFilterChange = (type) => {
    setLoading(true);
    setReview([]);
    setCurrentPage(1);
    setFeaturedReviews(type);
  };

  const handleLoading = (value) => {
    setTimeout(() => setLoading(value), 1000);
  };

  const handleReadMore = (page) => {
    setLoadingMore(true);
    setCurrentPage(page);
  };

  const { averageRatings, totalRatings, totalReviews } = reviewRatings;

  const ratingsBar = averageRatings?.sort((a, b) => {
    return b.rating - a.rating;
});
const slugclass = citySlug ? '' : 'flex-lg-row';
  return (
    <section className={styles.band_review_container} id="band-reviews">
      <div className={`container-fluid ${styles.band_review_wrapper}`}>
        <div className={`d-flex justify-content-start flex-column ${slugclass}`}>
          {citySlug ? 
          <h4 className={styles.band_review_title}>
                {cmsData?.review_heading !== undefined
                  ? cmsData?.review_heading
                  : "Customer Reviews"}
              </h4>
              : 
              <div className={styles.band_review_overview_sticky}>
              <div className={styles.band_review_overview}>
                <h4 className={styles.band_review_title}>
                  {cmsData?.review_heading !== undefined
                    ? cmsData?.review_heading
                    : "Customer Reviews"}
                </h4>
                <span className={styles.band_review_avg}>
                  {totalRatings !== undefined ? totalRatings.toPrecision(2) : 0}
                </span>
                <div className={styles.band_review_avg_stars}>
                  <Rating
                    name="half-rating-read"
                    size="large"
                    value={
                      totalRatings !== undefined ? totalRatings.toPrecision(2) : 0
                    }
                    precision={0.1}
                    icon={<StarRoundedIcon fontSize="inherit" />}
                    readOnly
                  />
                </div>
  
                <div className={styles.band_review_progress}>
                  {ratingsBar?.map(({ rating, percentage, count }) => (
                    <div
                      key={rating}
                      className={`d-flex flex-row flex-nowrap ${styles.band_review_progress_wrapper}`}
                    >
                      <div className={`mx-1 text-center ${styles.cstmr_revw_rate}`}>
                        {rating}
                      </div>
                      <Progress
                        className={`${styles.band_review_progress_bar} my-1`}
                        format={(percent) => percent + '%'}
                        percent={parseFloat(percentage).toFixed(0)}
                        strokeColor={colorCode[rating - 1]}
                        
                      />
                      <div className="mx-1 text-center">{count}</div>
                    </div>
                  ))}
                </div>
  
                <p className={styles.band_review_progress_timeline}>
                  {totalReviews ? totalReviews : 0} reviews over the past 12
                  months
                </p>
              </div>
            </div>
            }


          {loading === true ? (
            <div className={`${styles.band_review_loader} w-100`}>
              <Spin
                spinning={loading}
                indicator={
                  <LoadingOutlined
                    style={{ fontSize: 32, color: "#29a6ed" }}
                    spin
                  />
                }
              />
            </div>
          ) : (
            <div className="row w-100 align-items-start m-0">
              <div className={`d-flex align-items-center ${styles.band_review_filter} p-0`}>
                <div
                  className={`${styles.band_review_filter_item} px-2 ${
                    featuredReviews ? styles.active_filter : ""
                  }`}
                  onClick={() => !featuredReviews && handleFilterChange(true)}
                >
                  Featured
                </div>
                <span className="d-flex align-items-center">|</span>               
                <div
                  className={`${styles.band_review_filter_item} mx-2 ${
                    featuredReviews ? "" : styles.active_filter
                  }`}

                  onClick={() => featuredReviews && handleFilterChange(false)}
                >
                  Latest
                </div>
              </div>
              {reviews?.length > 0 ? (
                <div className={styles.band_review_review_list_container}>
                  <div className={styles.band_review_review_list}>
                    {reviews?.length !== undefined &&
                      reviews.map(
                        ({
                          _id,
                          reviewer: { name, profilePicture },
                          rating,
                          content,
                          createdAt,
                          eventDate,
                          image
                        }) => (
                          <div key={_id} className={styles.band_review_review}>
                            <div className="d-flex flex-row mb-3 align-items-center mt-3">
                              <img
                                className={styles.band_review_user_profile}
                                width="55px"
                                height="55px"
                                src={image ? process.env.IMAGE_LINK + image : "/assets/images/user_empty.svg"}
                                alt="user-profile"
                              />
                              <div>
                                <p className={styles.band_review_writtenby}>
                                  Written by
                                </p>
                                <p className={styles.band_review_username}>
                                  {name?.firstName !== null &&
                                  name?.firstName !== undefined &&
                                  name?.lastName !== null &&
                                  name?.lastName !== undefined
                                    ? `${name?.firstName} ${name?.lastName}`
                                    : "Unknown"}
                                </p>
                              </div>
                            </div>
                            <div className="d-flex flex-row mb-2 align-items-center">
                              <Rating
                                name="half-rating-read"
                                size="large"
                                value={rating}
                                precision={0.1}
                                style={{ paddingRight: 10 }}
                                icon={<StarRoundedIcon fontSize="inherit" />}
                                readOnly
                              />
                              <span className={styles.band_review_date}>
                                {moment.utc(eventDate).format("MMMM DD YYYY")}
                              </span>
                            </div>
                            {content !== "" && content !== undefined && (
                              <LongText content={content} limit={250} />
                            )}
                          </div>
                        )
                      )}
                  </div>
                  {reviews?.length < totalReviews && !loading && (
                    <>
                      {loadingMore ? (
                        <div className={styles.band_review_loadingmore}>
                          <p>Loading...</p>
                        </div>
                      ) : (
                        <div
                          className={styles.band_review_readmore}
                          onClick={() => handleReadMore(currentPage + 1)}
                        >
                          <p>Read more</p>
                        </div>
                      )}
                    </>
                  )}
                </div>
              ) : (
                <div className={styles.band_review_empty_container}>
                  <p>No Review Found</p>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default ReviewComponent;
